import React from 'react';
import { TicketSite } from '../../../entities/ticket/model/types';
import * as S from './SiteModal.styles';

interface SiteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (site: TicketSite) => void;
  currentSite?: TicketSite;
}

const siteOptions: Array<{ value: TicketSite; label: string }> = [
  { value: 'hudle', label: 'Hudle' },
  { value: 'tournament', label: 'Турнирный сайт' },
  { value: 'unknown', label: 'Неизвестен' },
];

export const SiteModal: React.FC<SiteModalProps> = ({
  isOpen,
  onClose,
  onSelect,
  currentSite,
}) => {
  const handleSelect = (site: TicketSite) => {
    onSelect(site);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <S.ModalOverlay onClick={onClose}>
      <S.ModalContent onClick={(e) => e.stopPropagation()}>
        <S.ModalHeader>
          <S.ModalTitle>Выберите сайт</S.ModalTitle>
          <S.CloseButton onClick={onClose}>×</S.CloseButton>
        </S.ModalHeader>

        <S.SiteList>
          {siteOptions.map(option => (
            <S.SiteItem
              key={option.value}
              $selected={currentSite === option.value}
              onClick={() => handleSelect(option.value)}
            >
              {option.label}
            </S.SiteItem>
          ))}
        </S.SiteList>
      </S.ModalContent>
    </S.ModalOverlay>
  );
};




